module.exports = __webpack_public_path__ + "assets/img/free_20.519b6a47.png";